import { useTranslation } from "@repo/translation";
import { logError } from "@repo/utils";
import { type Locale, format } from "date-fns";

interface LocalizedDateProps {
  date: string | Date;
}

export const LocalizedDayDate = ({ date }: LocalizedDateProps) => {
  const { dateFnsLocale } = useTranslation();
  if (!date) {
    return null;
  }
  return <>{localizedDayDate(date, dateFnsLocale)}</>;
};

export const localizedDayDate = (
  date: string | Date,
  dateFnsLocale?: Locale
) => {
  try {
    const d = date instanceof Date ? date : new Date(date);
    return format(d, "EEEE, dd LLL", { locale: dateFnsLocale });
  } catch (e) {
    logError(e, [{ tagName: "date", tagValue: date?.toString() }]);
    return "-";
  }
};
